import React, { useEffect, useState } from 'react';
import { TbCash } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';
import ButtonPrimary from '../../Form/ButtonPrimary';
import { useCheckoutContext } from '../../../Contexts/CheckoutContext';
import InputCurrency from '../../Form/InputCurrency';
import ButtonClose from '../../Form/ButtonClose';
import { formatCurrency } from '../../../Utils/Formatters';

interface ChangeAmountProps {
    onSuccess: CallableFunction;
    onCancel: CallableFunction; 
    cart: any;
}
const ChangeAmount = ({ onSuccess = () => {}, onCancel = () => {}, cart }: ChangeAmountProps) => {

    const { t } = useTranslation();
    const { paymentMethod, setPaymentMethod } = useCheckoutContext();
    const [ showFormAmount, setShowFormAmount ] = useState<boolean>(paymentMethod.cash_amount);

    const handleChangeAmount = (value: any) => {
        setPaymentMethod({
            ...paymentMethod,
            cash_amount: Number(value || 0)
        });
    }

    //* Valor inicial do troco para ser utilizado no cancelamento
    const [initialCashAmount] = useState(paymentMethod.cash_amount);

    //* Total com desconto e pontos
    const totalWithDiscountAndPoints = Number(cart?.total_with_discount) - Number(cart?.value_points || 0);

    const handleCancel = () => {
        setPaymentMethod({
            ...paymentMethod,
            cash_amount: initialCashAmount
        });
        onCancel();
    }

    useEffect(() => {
        if(paymentMethod.cash_amount) {
            setShowFormAmount(true);
        }
    }, [paymentMethod]);

    return (
        <section className='flex flex-col items-center w-full p-6 gap-8'>

            <h4 className='flex flex-col items-center'>
                <span className='mb-2'>
                    <TbCash size={55} className="zoomInIcon" />
                </span>
                <span className='font-extrabold text-2xl leading-6'>
                    {showFormAmount
                        ?   t('checkout.change_amount.title_form')
                        :   t('checkout.change_amount.title')
                    }
                </span>
                {!showFormAmount && <span className='leading-5'>{t('checkout.change_amount.message')}</span>}
            </h4>

            {(showFormAmount || paymentMethod.cash_amount) ? (
                <>
                    <div className='flex flex-col gap-2 w-full'>
                        <div className='w-full relative flex items-center justify-between'>
                            <span className='absolute left-3 text-gray-400'>{t('checkout.change_amount.badge_label')}</span>
                            <InputCurrency value={paymentMethod.cash_amount} autoFocus onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeAmount(e.target.value)} className=' pr-10 text-2xl text-shopfood-title font-extrabold' />
                            <ButtonClose disabled={paymentMethod.cash_amount === 0} onClick={() => handleChangeAmount(0)} className='absolute right-2' />
                        </div>
                        {paymentMethod.cash_amount > 0 && paymentMethod.cash_amount < totalWithDiscountAndPoints && (
                            <div className='text-xs font-medium leading-none text-shopfood-error'>
                                {t('checkout.change_amount.error_message_total_value', { value: formatCurrency(totalWithDiscountAndPoints) })}
                            </div>
                        )}
                    </div>

                    <div className='flex flex-wrap justify-center gap-2 w-full'>
                        <ButtonPrimary 
                            disabled={paymentMethod.cash_amount > 0 && paymentMethod.cash_amount < cart.total_with_discount}
                            onClick={onSuccess} className="flex-1 text-nowrap">{
                            paymentMethod.cash_amount === 0
                                ?   t('checkout.change_amount.button_not_need')
                                :   t('checkout.change_amount.button_confirm')
                            }
                        </ButtonPrimary>
                        <ButtonPrimary outline onClick={handleCancel} className="flex-1 text-nowrap">{t('checkout.change_amount.button_cancel')}</ButtonPrimary>
                    </div>
                </>
            ) : (
                <>
                <div className='flex flex-wrap justify-center gap-2 w-full'>
                    <ButtonPrimary onClick={() => setShowFormAmount(true)} className="flex-1 text-nowrap">{t('checkout.change_amount.button_need')}</ButtonPrimary>
                    <ButtonPrimary outline onClick={() => onCancel()} className="flex-1 text-nowrap">{t('checkout.change_amount.button_not_need')}</ButtonPrimary>
                </div>
            </>
            )}



        </section>
    )
};

export default ChangeAmount;
